import { Checkbox } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./quotaCopySlice";

export default function TableColCheckbox() {
   const dispatch = useDispatch();
   const quotaCopy = useSelector((state) => state.quotaCopy);
   const { selectedTableRows, quotaDetailsTable, tableColChecked } = quotaCopy;
   const { rows } = quotaDetailsTable;
   
   function handleChange(event) {
      const checked = event.target.checked;
      dispatch(setState("tableColChecked", checked));
      let selectedRows = [...selectedTableRows];

      const tableRows = rows.map((item) => {
         return {
            ...item,
            checked: checked,
         };
      });

      if (checked) {
         for (let i = 0; i < rows.length; ++i) {
            const rowID = rows[i].id;
            const item = selectedRows.find((id) => id === rowID);
            if (item === undefined && rows[i].quotaStatus !== "Approved") {
               selectedRows.push(rowID);
            }
         }
      } else {
         selectedRows = [];
      }
      dispatch(setState("selectedTableRows", selectedRows));
      dispatch(setState("quotaDetailsTable", { rows: tableRows }));
   }

   return (
      <div>
         <Checkbox
            checked={tableColChecked}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
         />
      </div>
   );
}
